import { render, staticRenderFns } from "./ActionItemsList.vue?vue&type=template&id=0dd153ae&scoped=true"
import script from "./ActionItemsList.vue?vue&type=script&lang=js"
export * from "./ActionItemsList.vue?vue&type=script&lang=js"
import style0 from "./ActionItemsList.vue?vue&type=style&index=0&id=0dd153ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd153ae",
  null
  
)

export default component.exports